import NiceSelect from 'nice-select2';
import { PLPhoneFormatter } from '../../../assets/scripts/extensions/phoneFormatter/PLPhoneFormatter.js';
import { postalFormatter } from '../../../assets/scripts/extensions/postalFormatter/postalFormatter.js';


// Inicjalizacja jednego selecta
const initNiceSelect = (select) => {
    if (!select) return;
    NiceSelect.bind(select, {
        searchable: false,
        searchtext: 'Szukaj…',
        selectedtext: ' wybrano',
        placeholder: 'Wybierz'
    });
};

// Inicjalizacja wielu selectów z klasą .js-nice
const initAll = () => {
    document.querySelectorAll('select.js-nice').forEach(initNiceSelect);
};

// Odpal po załadowaniu DOM
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
} else {
    initAll();
}

// form-validate.js
(() => {
    const onReady = (fn) =>
        document.readyState === 'loading'
            ? document.addEventListener('DOMContentLoaded', fn, { once: true })
            : fn();

    onReady(() => {
        // 1) Znajdź formularz
        const form =
            document.getElementById('contact-form') ||
            document.querySelector('form.form') ||
            document.querySelector('form');
        if (!form) return;

        form.setAttribute('novalidate', '');

        // 2) Uniwersalne wyszukiwarki pól (ID, name, type)
        const find = (list) => list.map((sel) => form.querySelector(sel)).find(Boolean);

        const fields = {
            topic: find(['select[name*="topic" i]', '#topic', 'select[required]']),
            name: find([
                'input#name',
                'input[name*="name" i]',
                'input[name*="imi" i]',
                'input[name*="nazw" i]',
            ]),
            company: find(['input#company', 'input[name*="company" i]', 'input[name*="firma" i]']),
            email: find(['input#email', 'input[type="email"]', 'input[name*="mail" i]']),
            phone: find(['input#phone', 'input[type="tel"]', 'input[name*="tel" i]', 'input[name*="phone" i]']),
            postal: find([
                'input#zip',
                'input#postal_code',
                'input[name*="zip" i]',
                'input[name*="kod" i]',
                'input[name*="postal" i]',
                'input[name*="postcode" i]',
            ]),
            city: find(['input#city', 'input[name*="city" i]', 'input[name*="miast" i]']),
            message: find(['textarea#message', 'textarea[name*="message" i]', 'textarea[name*="wiad" i]']),
        };

        // 3) Render/clear błędów
        const hostOf = (input) => input.closest('.form__group') || input.parentElement || input;
        const setError = (input, msg) => {
            if (!input) return false;
            input.setAttribute('aria-invalid', 'true');
            const host = hostOf(input);
            let err = host.querySelector('.form__error');
            if (!err) {
                err = document.createElement('div');
                err.className = 'form__error';
                err.setAttribute('role', 'alert');
                host.appendChild(err);
            }
            err.textContent = msg;
            return false;
        };
        const clearError = (input) => {
            if (!input) return;
            input.setAttribute('aria-invalid', 'false');
            const err = hostOf(input).querySelector('.form__error');
            if (err) err.remove();
        };

        // 4) Formatery (maski)
        PLPhoneFormatter('#phone');
        postalFormatter('#zip');

        // 5) Reguły walidacji
        const emailBasic = (v) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v);
        const validators = {
            topic: () => {
                const el = fields.topic;
                if (!el) return true;
                const v = (el.value || '').trim();
                return v ? (clearError(el), true) : setError(el, el.dataset.msg);
            },
            name: () => {
                const el = fields.name;
                if (!el) return true;
                const v = (el.value || '').trim();
                if (!v) return setError(el, el.dataset.msg);
                if (v.length < 3) return setError(el, el.dataset.to_short);
                clearError(el); return true;
            },
            email: () => {
                const el = fields.email;
                if (!el) return true;
                const v = (el.value || '').trim();
                if (!v) return setError(el, el.dataset.msg);
                if (!v.includes('@')) return setError(el, el.dataset.monkey);
                if (!emailBasic(v)) return setError(el, el.dataset.true-email);
                clearError(el); return true;
            },
            phone: () => {
                const el = fields.phone;
                if (!el) return true;
                const v = (el.value || '').trim();
                if (!v) return setError(el, el.dataset.msg);
                if (!/^\+48 \d{3} \d{3} \d{3}$/.test(v)) return setError(el, el.dataset.format);
                clearError(el); return true;
            },
            postal: () => {
                const el = fields.postal;
                if (!el) return true;
                const v = (el.value || '').trim();
                if (!v) return setError(el, el.dataset.msg);
                if (!/^\d{2}-\d{3}$/.test(v)) return setError(el, el.dataset.format);
                clearError(el); return true;
            },
            city: () => {
                const el = fields.city;
                if (!el) return true;
                const v = (el.value || '').trim();
                return v ? (clearError(el), true) : setError(el, el.dataset.msg);
            },
            message: () => {
                const el = fields.message;
                if (!el) return true;
                const v = (el.value || '').trim();
                if (!v) return setError(el, el.dataset.msg);
                if (v.length < 10) return setError(el, el.dataset.to_short);
                clearError(el); return true;
            },
        };

        // Inne pola — czyszczenie błędów przy wpisywaniu + walidacja na blur
        [['name','email','city','message']].flat().forEach((k) => {
            const el = fields[k];
            if (!el) return;
            el.addEventListener('input', () => clearError(el));
            el.addEventListener('blur', validators[k]);
        });
        fields.topic?.addEventListener('change', validators.topic);
        fields.topic?.addEventListener('blur', validators.topic);

        // 7) Submit
        const submitButton = form.querySelector('[type="submit"]');
        const inputs = form.querySelectorAll('input:not([type=hidden]):not([type=submit])');
        const textareas = form.querySelectorAll('textarea');

        function showMessage(message, type = 'success') {
            const messageEl = document.querySelector('.form__message');

            messageEl.textContent = message;
            messageEl.className = 'form__message ' + type;

            // pokaż element
            messageEl.style.display = 'inline-block';
            setTimeout(() => {
                messageEl.classList.add('visible');
            }, 10);

            // po 5 sekundach fade out
            setTimeout(() => {
                messageEl.classList.remove('visible');
                setTimeout(() => {
                    messageEl.style.display = 'none';
                }, 400); // musi być równe transition w CSS
            }, 7000);
        }

        function disableSubmitButton() {
            submitButton.disabled = true;
            submitButton.style.opacity = '0.6';
            submitButton.setAttribute('aria-disabled', 'true');

            // Dodaj loader
            if (!submitButton.querySelector('.loader')) {
                const loader = document.createElement('span');
                loader.classList.add('loader');
                loader.style.marginLeft = '8px'; // odstęp od tekstu
                submitButton.appendChild(loader);
            }
        }

        function enableSubmitButton() {
            submitButton.disabled = false;
            submitButton.style.opacity = '1';
            submitButton.removeAttribute('aria-disabled');

            // Usuń loader
            const loader = submitButton.querySelector('.loader');
            if (loader) {
                loader.remove();
            }
        }

        function resetInputs() {
            inputs.forEach(el => el.value = '');
            textareas.forEach(el => el.value = '');
        }

        function resetGrecaptcha(form) {
            if (!form) return;

            const responseField = form.querySelector("[name='g-recaptcha-response']");
            if (!responseField) return;

            grecaptcha.ready(function () {
                grecaptcha.execute(recaptchaSiteKey, { action: form.getAttribute('action') })
                    .then(function (token) {
                        responseField.value = token;
                    })
                    .catch(function (error) {
                        console.error("Błąd reCAPTCHA:", error);
                    });
            });
        }

        form.addEventListener('submit', function (e) {
            e.preventDefault();

            const ok =
                (validators.topic() & 1) &
                (validators.name() & 1) &
                (validators.email() & 1) &
                (validators.phone() & 1) &
                (validators.postal() & 1) &
                (validators.city() & 1) &
                (validators.message() & 1);

            if (!ok) {
                const first = form.querySelector('[aria-invalid="true"]');
                if (first) {
                    first.focus({ preventScroll: true });
                    first.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                return;
            }

            disableSubmitButton();

            grecaptcha.ready(function () {
                grecaptcha.execute(recaptchaSiteKey, { action: form.getAttribute('action') })
                    .then(function (token) {
                        form.querySelector("[name='g-recaptcha-response']").value = token;
                        sendForm(form);
                    })
                    .catch(function (error) {
                        showMessage(form.dataset.recaptcha_error, 'error');
                        console.error(error);
                        enableSubmitButton();
                    });
            });
        });

        function sendForm(form) {
            const url = form.getAttribute('action');
            const formData = new FormData(form);

            fetch(url, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
                .then(res => res.json())
                .then(data => {
                    // Backend zwrócił sukces
                    if (data.code === 200) {
                        showMessage(data.message);
                        resetInputs();
                        resetGrecaptcha(form);
                    }
                    // Backend zwrócił błędy walidacji
                    else if (data.errors) {
                        showMessage(form.dataset.form_error, 'error');

                        // Usuń wcześniejsze aria-invalid
                        form.querySelectorAll('[aria-invalid]').forEach(el => el.removeAttribute('aria-invalid'));
                        form.querySelectorAll('.form__error').forEach(el => el.remove()); // usuń wcześniejsze komunikaty

                        Object.keys(data.errors).forEach(fieldName => {
                            const field = form.querySelector(`[name="${fieldName}"]`);
                            if (field) {
                                field.setAttribute('aria-invalid', 'true');

                                // Pobierz pierwszy błąd z tablicy
                                let backendError = data.errors[fieldName][0];

                                // Jeśli pole ma data-msg, użyj go zamiast backendowego klucza
                                const message = field.dataset.msg || backendError || "Błąd";

                                // Dodaj komunikat do .form__error
                                let errorEl = field.parentNode.querySelector('.form__error');
                                if (!errorEl) {
                                    errorEl = document.createElement('div');
                                    errorEl.classList.add('form__error');
                                    errorEl.style.color = 'red'; // jeśli nie ma stylów w CSS
                                    field.parentNode.appendChild(errorEl);
                                }
                                errorEl.textContent = message;
                            }
                        });

                        // focus na pierwszym błędzie
                        const firstError = form.querySelector('[aria-invalid="true"]');
                        if (firstError) {
                            firstError.focus({ preventScroll: true });
                            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }
                    }

                    else {
                        showMessage(data.message || form.dataset.sending_error, 'error');
                    }
                })
                .catch(err => {
                    console.error(err);
                    showMessage(form.dataset.network_error, 'error');
                })
                .finally(() => {
                    enableSubmitButton();
                });
        }

    });
})();
